import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--sidebar"
export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    this.close()
  }

  toggle() {
    if (this.sidebarTarget.classList.contains('-translate-x-full')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.sidebarTarget.classList.remove('-translate-x-full')
    this.overlayTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.sidebarTarget.classList.add('-translate-x-full')
    this.overlayTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }
}
